module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "typelist",
    on: {
      "click": function($event) {
        _vm.itemClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "typelist-detail",
    class: _vm.align
  }, [_c('span', {
    class: _vm.icon,
    staticStyle: {
      "font-size": "0.67rem",
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "name",
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.name))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4674975d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu_item.vue
// module id = 216
// module chunks = 3